module.exports = __webpack_public_path__ + "3a90329a49f0b1eba3cc0466f6d8a9d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-running.png
// module id = 2436
// module chunks = 0